import plantsClient from '@/core/services/plants';
import { SET_APP_LOADING } from '@/core/store/action-types';
import { HANDLE_REFRESH_PLANT } from '@/core/utils/emitter-events';
import AddDeviceToLinkableObject from '@/views/components/AddDeviceToLinkableObject/AddDeviceToLinkableObject.vue';
import {
  DeviceDTO,
  DevicesFilterByType,
  SlotStatus,
  ThermoActuatorType,
} from '@/../client-generator/generated-clients/plants';
import { Options } from 'vue-class-component';
import ThermoGeneralStep from '../ThermoGeneralStep';
import { getCurrentThermoActuatorType } from '@/core/utils/utils';

@Options({
  name: 'StepAssignTheCoolingPump',
  components: {
    AddDeviceToLinkableObject,
  },
  watch: {
    atLeastOneDeviceAndSlotSelected: function () {
      this.validateNextEnabled();
    },
  },
})
export default class StepAssignTheCoolingPump extends ThermoGeneralStep {
  devicesCoolingPumps: DeviceDTO[] = [];

  get currentDevicesCoolingPumps() {
    return this.roomObject.devices?.filter((x) => x.isActuatorDevice);
  }

  created() {
    this.validateNextEnabled();
  }

  async mounted() {
    this.$store.dispatch(SET_APP_LOADING, true);

    try {
      this.devicesCoolingPumps = await plantsClient.devices(
        this.plantId,
        this.roomId,
        this.roomObject.id ?? '',
        DevicesFilterByType.THERMO_COOLING_PUMPS,
        undefined,
        this.roomObject.heatingSystemControlType || undefined,
        this.roomObject.coolingSystemControlType || undefined,
        this.roomObject.sharedSystemControlType || undefined
      );
    } catch (error) {
      let messageError = '';

      switch (error.status) {
        case 409:
          this.$emitter.emit(HANDLE_REFRESH_PLANT);
          this.$router.push({
            name: 'page-plant-dashboard',
            params: this.$route.params,
          });
          break;
        default:
          messageError = this.$t('apiErrors.serverError').toString();
      }

      if (messageError) {
        this.$toast.add({
          severity: 'error',
          summary: this.$t('general.operationError'),
          closable: true,
          life: 3000,
        });
      }
    } finally {
      this.$store.dispatch(SET_APP_LOADING, false);
    }
  }

  get atLeastOneDeviceAndSlotSelected() {
    return (
      this.currentDevicesCoolingPumps?.some((k) =>
        k.slots?.some(
          (s) =>
            (s.status == SlotStatus.MarkedForLinking ||
              (s.status == SlotStatus.Configured &&
                s.linkedObjects?.some((l) => l.id === this.roomObject.id))) &&
            [
              ThermoActuatorType.CoolingPump,
              ThermoActuatorType.HeatingAndCoolingPump,
            ].includes(
              getCurrentThermoActuatorType(
                s.thermoActuatorTypes,
                this.roomObject.id
              )
            )
        )
      ) ?? false
    );
  }

  validateNextEnabled() {
    this.nextEnabled = this.atLeastOneDeviceAndSlotSelected;
  }
}
